import './Chart.css'
import React from 'react'
import { Line, LineChart, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Brush } from 'recharts'

export default class Chart extends React.Component {
  constructor (props) {
    super(props)
    this.data = props.data
    this.lines = props.lines
    this.XAxisDataKey = props.XAxisDataKey
    this.YAxisType = props.YAxisType
    this.YAxisDomain = props.YAxisDomain
    this.brushDataKey = props.brushDataKey
  }

  render () {
    const { data, lines, XAxisDataKey, YAxisType, YAxisDomain, brushDataKey } = this.props
    return (
      <div className='chart'>
        <ResponsiveContainer width='100%' height='100%'>
          <LineChart
            width={800}
            height={400}
            data={data}
          >
            <CartesianGrid strokeDasharray='3 3' />
            {
              lines.map((line, index) => (
                <Line
                  key={index}
                  type='monotone'
                  strokeWidth={line.strokeWidth || '5'}
                  name={line.name || null}
                  dataKey={line.dataKey}
                  stroke={line.stroke || '#6C1137'}
                />
              ))
            }
            <XAxis
              dataKey={XAxisDataKey || null}
              tick={{ fontSize: 12, fill: 'black' }}
            />
            <YAxis
              tick={{ fontSize: 10, fill: 'black' }}
              tickCount={20}
              type={YAxisType || 'number'}
              domain={YAxisDomain || ['dataMin - 1', 'dataMax + 1']}
              className='hide-to-print'
            />
            <Tooltip itemStyle={{ fontSize: 14 }} className='hide-to-print' />
            {brushDataKey && (<Brush dataKey={brushDataKey} height={30} stroke='#6C1137' className='hide-to-print' />)}
          </LineChart>
        </ResponsiveContainer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Chart/Chart.jsx